import { grey } from '@material-ui/core/colors'
import { createTheme } from '@material-ui/core/styles'

/**
* define styles for the component
*/
// Create a theme instance.
const JustiTheme = createTheme({
  palette: {
    primary: {
      main: '#111111',
      light: '#535353',
    },
    secondary: {
      dark: '#0A3740',
      main: '#25D8FC',
      light: '#C2F4FE',
    },
    error: {
      main: '#D7263D',
    },
    background: {
      default: grey[100],
    },
  },
})

export default JustiTheme